import React, { useState } from 'react';
import moment from 'moment';

interface Props {
    timeString: string;
    timeStringIsFormatted?: boolean;
}
const MessageItemSent = ({ timeString, timeStringIsFormatted }: Props) => {
    const [formatSentDate, setFormatSentDate] = useState('LT');
    const formatDate = timeStringIsFormatted
        ? timeString
        : moment(timeString).format(formatSentDate);

    return (
        <div
            onMouseEnter={() => setFormatSentDate('YYYY-MM-DD LTS')}
            onMouseLeave={() => setFormatSentDate('LT')}
        >
            {formatDate}
        </div>
    );
};

export default React.memo(MessageItemSent);
